/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiArchivePreview, ApiBlobDataset, ApiPrintOption, ApiPrintOptionPayload } from '@Model';
import type { HttpActions, ListRequestWithIds, ResponseResolver, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PrintOptionsController.
 */
export class PrintOptionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /print_options
     */
    public getPrintOptions(): Promise<Result<ApiPrintOption[]>> {
        return this.http.get<Result<ApiPrintOption[]>>('/print_options');
    }

    /**
     * Calls POST /print_options
     */
    public getPrintOptionsInCategory(data: ApiPrintOptionPayload, category: string): Promise<Result<ApiPrintOption[]>> {
        const query = new URLSearchParams();
        query.set('category', `${category}`);

        return this.http.post<Result<ApiPrintOption[]>, ApiPrintOptionPayload>('/print_options', data, query);
    }

    /**
     * Calls GET /print_options/{printOptionId}
     */
    public getPrintOptionGet(printOptionId: string): Promise<Result<ApiPrintOption>> {
        return this.http.get<Result<ApiPrintOption>>(`/print_options/${printOptionId}`);
    }

    /**
     * Calls POST /print_options/{printOptionId}
     */
    public getPrintOptionPost(printOptionId: string, data: ApiPrintOptionPayload): Promise<Result<ApiPrintOption>> {
        return this.http.post<Result<ApiPrintOption>, ApiPrintOptionPayload>(`/print_options/${printOptionId}`, data);
    }

    /**
     * Calls POST /print_options/{printOption}/datasets/json
     */
    public getJsonDatasets(printOption: string, data: ApiPrintOptionPayload): Promise<Result<Record<string, string>>> {
        return this.http.post<Result<Record<string, string>>, ApiPrintOptionPayload>(`/print_options/${printOption}/datasets/json`, data);
    }

    /**
     * Calls GET /print_options/{printOption}/datasets/blob
     */
    public getBlobDatasets(printOption: string): Promise<Result<Record<string, ApiBlobDataset>>> {
        return this.http.get<Result<Record<string, ApiBlobDataset>>>(`/print_options/${printOption}/datasets/blob`);
    }

    /**
     * Calls GET /print_options/{printOptionId}/{primaryId}
     */
    public printDocument<TResponse = unknown>(printOptionId: string, primaryId: string, force: boolean, responseResolver?: ResponseResolver<TResponse>): Promise<TResponse> {
        const query = new URLSearchParams();
        query.set('force', `${force}`);

        return this.http.get<TResponse>(`/print_options/${printOptionId}/${primaryId}`, query, responseResolver);
    }

    /**
     * Calls POST /print_options/{printOptionId}/archive_preview
     */
    public getArchivePreview(printOptionId: string, selection: ListRequestWithIds): Promise<Result<ApiArchivePreview>> {
        return this.http.post<Result<ApiArchivePreview>, ListRequestWithIds>(`/print_options/${printOptionId}/archive_preview`, selection);
    }

    /**
     * Calls GET /print_options/{printOptionId}/{primaryId}/attachments
     */
    public printAttachments<TResponse = unknown>(printOptionId: string, primaryId: string, responseResolver?: ResponseResolver<TResponse>): Promise<TResponse> {
        return this.http.get<TResponse>(`/print_options/${printOptionId}/${primaryId}/attachments`, undefined, responseResolver);
    }
}
